var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('section',{staticClass:"d-flex body-content",staticStyle:{"background-color":"#f1f3f4"}},[_c('h1',[_vm._v("Lobby Template 6")])])])
}]

export { render, staticRenderFns }